<script module lang="ts">
  const players = new Set<HTMLAudioElement>();

  export const playing = $state({
    track: '',
    artUrl: '',
  });

  export const stopAll = () => {
    players.forEach((p) => p.pause());
  };

  const bucket =
    'https://dohysbywpvqieovitawt.supabase.co/storage/v1/object/public/soundtrack';
  let tracks = shuffle([
    'Apple',
    'Apricot',
    'Blackberry',
    'Blueberry',
    'Boysenberry',
    'Cherry',
    'Cranberry',
    'Elderberry',
    'Fig',
    'Mango',
    'Persimmon',
    'Plum',
    'Raspberry',
    'Rhubarb',
    'Strawberry',
    'Pear',
    'Huckleberry',
  ]);

  let player: HTMLAudioElement;
  export const showPlayer = new PersistedState('show-player', true);
  export const musicPaused = new PersistedState('music-paused', true);
  export const musicVolume = new PersistedState('music-volume', 1);

  let audioIdx = 0;
  playing.track = tracks[audioIdx];
  const logPlay = (state: 'play' | 'pause') => {
    // TODO
    // supabaseClient.from('click_analytics').insert({
    //   userId: getUserId(),
    //   buttonId: `${state}-soundtrack`
    // })
  };

  export const toggleSoundtrack = async () => {
    if (!player) return;
    if (player.paused && !showPlayer.current) {
      resume();
      showPlayer.current = true;
    } else {
      pause();
      showPlayer.current = false;
    }
  };

  export const resume = async () => {
    if (player.paused) {
      logPlay('play');
      if (!player.src) {
        player.src = `${bucket}/${tracks[0]}.mp3`;
      }
      await player.play();
      musicPaused.current = false;
      if ('mediaSession' in navigator) {
        navigator.mediaSession.playbackState = 'playing';
      }
    }
  };

  export const pause = () => {
    if (!player.paused) logPlay('pause');
    player.pause();
    musicPaused.current = true;
    if ('mediaSession' in navigator) {
      navigator.mediaSession.playbackState = 'paused';
    }
  };

  export const skipForward = () => {
    audioIdx = (audioIdx + 1) % tracks.length;
    play(tracks[audioIdx]);
  };

  export const skipBack = () => {
    audioIdx = (audioIdx + 1) % tracks.length;
    if (audioIdx < 0) {
      audioIdx += tracks.length;
    }
    play(tracks[audioIdx]);
  };

  const play = async (file: string) => {
    playing.track = tracks[audioIdx];
    player.src = `${bucket}/${file}.mp3`;
    await player.play();
    updateMetadata(file);
    updatePositionState();
  };

  const updateMetadata = (file: string) => {
    if ('mediaSession' in navigator) {
      const url = `${bucket}/${file}.jpg`;
      playing.artUrl = url;
      navigator.mediaSession.metadata = new MediaMetadata({
        title: file,
        artist: 'Gram Jam',
        artwork: [
          {
            src: url,
            sizes: '512x512',
            type: 'image/jpeg',
          },
        ],
      });
    }
  };

  const updatePositionState = () => {
    if ('setPositionState' in navigator.mediaSession) {
      navigator.mediaSession.playbackState = 'playing';
      // navigator.mediaSession.setPositionState({
      //   duration: player.duration,
      //   playbackRate: player.playbackRate,
      //   position: player.currentTime,
      // });
    }
  };
</script>

<script lang="ts">
  import { onMount } from 'svelte';
  import { shuffle } from '~/algorithms/shuffle';
  import { PersistedState } from 'runed';

  onMount(() => {
    players.add(player);
    if (!musicPaused.current) {
      play(tracks[0]);
    }
    if ('mediaSession' in navigator) {
      navigator.mediaSession.setActionHandler('play', resume);
      navigator.mediaSession.setActionHandler('pause', pause);
      navigator.mediaSession.setActionHandler('nexttrack', skipForward);
      navigator.mediaSession.setActionHandler('previoustrack', skipBack);
    }
  });
</script>

<audio
  bind:this={player}
  bind:volume={musicVolume.current}
  bind:paused={musicPaused.current}
  onended={skipForward}
></audio>
